const {h, render, Component} = require('preact');
const {route} = require('preact-router')
const qs = require('qs')
const OrderView = require('../../views/main/order')

class Order extends Component {
  constructor(props) {
    super(props);
    if(this.props.item)
      this.orderId = this.props.item.id
    this.routeToDetails = this.routeToDetails.bind(this);
    this.isReceivedGift = this.isReceivedGift.bind(this);
    this.getVoucherId = this.getVoucherId.bind(this);
  }

  isReceivedGift() {
    if (this.props && this.props.item && this.props.item.giftInfo) {
      return this.props.item.giftInfo.isReceivedGift;
    }
    return false;
  }

  getVoucherId() {
    if (this.props && this.props.item && Array.isArray(this.props.item.groupons)) {
      return this.props.item.groupons[0].id;
    }
  }

  routeToDetails(event) {
    const queryParamsGiftedVoucher = {
      order_id: this.orderId,
      is_received_gift: this.isReceivedGift(),
      voucher_id: this.getVoucherId()
    }

    const queryStringGiftedVoucher = qs.stringify(queryParamsGiftedVoucher);

    let dataBhwValue = event.target.getAttribute("data-bhw")

    if (dataBhwValue && (dataBhwValue.startsWith("web2018_trade_in") || dataBhwValue.startsWith("web2018_ssa"))) {
        return;
    }
    else {
      if (this.props.item.isPayToClaim) {
        route(`/customer_support/web/claim/summary?claimId=${this.props.item.claimId}`);
      } else if (this.props.item.isGift) {
        route(`/customer_support/web/order?${queryStringGiftedVoucher}`)
      }
      else {
        route(`/customer_support/web/order?order_id=${this.orderId}`);
      }
    }
  }

  render(props, state) {
    return (
        <OrderView
            order={props.item}
            orderDetails={this.routeToDetails.bind(this)}
        />
    )
  }
}

module.exports = Order
